(function () {
  'use strict';
  angular
    .module('frontendApp', ['ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.router',
      'ui.bootstrap',
      'toastr',
      'LocalStorageModule',
      'sap.imageloader',
      'ngMap',
      'swipe',
      'fox.scrollReveal',
      'angularSmoothscroll',
      'angular-inview',
      'angular-owl-carousel-2'
    ]);

})();


'use strict';
angular
  .module('frontendApp')
  .factory('ContentService', function ($http, $rootScope) {
    return {
      // GETDATA USAGE
      // CONFIG
      //    'Model' (String)
      //    'Params' (Object)
      //       |_'per_page'(int)
      //       |_'page' (int)
      //       |_'orderBy' (string)
      //       |_'selected' (find register searching by ID)
      //       |_'filters' (Object)
      //            |_'name of the field to be searched for' (Object)
      //                 |_'operator' (String) 'like', '=', '>', '>=', '<', '<='
      //                 |_'value' (String | int | date)
      // USE EXAMPLE
      //     ContentService.getdata( 'homenews', {
      //        per_page: 5,
      //        page: 1,
      //        filters: {
      //          title: {operator: 'like', value: 'World'},
      //          status: {value: 1},
      //          created_at: {operator: '>', value: '2018-01-01'}
      //        }
      //      })
      //      .success(function (res) { console.log('success', res); });
      getdata: function (table, params) {
        console.log('BEFORE REQUEST', table, params)
        return $http.post($rootScope.api + '/api/' + table + '/getdata', params);
      },
      // RETURNS ALL THE WEB CONTENTS
      webcontent: function (state) {
        var params = {
          state : state
        };
        return $http.post($rootScope.api + '/api/webcontent', params);
      },
      // WEB FORMS SERVICE
      sendform: function (params) {
        return $http.post($rootScope.api + '/api/sendform', params);
      },
      // RETURN TRANSLATIONS
      fixedcontent: function () {
        return $http.get('assets/fixedcontent.json');
      }


    };
  });

(function () {
  'use strict';
  angular
    .module('frontendApp')
    //establece altura a pantalla completa
    .directive('windowheight', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $(window).resize(function () {
            element.css({minHeight: $(window).height()});
            //console.log('exit')
          }).resize();
        }
      };
    })
    //carga video
    .directive('myYoutube', function ($sce) {
      return {
        restrict: 'EA',
        scope: {code: '='},
        replace: true,
        template: '<div style="height:200px;"><iframe style="overflow:hidden;height:100%;width:100%" width="100%" height="100%" src="{{url}}" frameborder="0" allowfullscreen></iframe></div>',
        link: function (scope) {
          //console.log('here');
          scope.$watch('code', function (newVal) {
            if (newVal) {
              scope.url = $sce.trustAsResourceUrl("http://www.youtube.com/embed/" + newVal);
            }
          });
        }
      };
    })
    //Iguala altura entre elementos
    //targetclass = nombre de la clase para igualar alturas de elementos
    .directive('equalheight', function ($timeout) {
      return {
        restrict: 'A',
        scope: {
          targetclass: '@'
        },
        link: function (scope, element) {
          $(window).resize(function () {
            //console.log(scope.targetclass)
            $timeout(function () {
              var x = document.getElementsByClassName(scope.targetclass);
              var temp = 0;
              for (var i = 0; i < x.length; i++) {
                if (temp < x[i].offsetHeight) {
                  temp = x[i].offsetHeight;
                }
              }
              //console.log('maximo altura detectada', temp);
              element.css({minHeight: temp});
            }, 1000);
          }).resize();
        }
      };
    })
    //Iguala altura entre elementos
    //targetclass = nombre de la clase para igualar alturas de elementos
    .directive('squareheight', function ($timeout) {
      return {
        restrict: 'A',
        scope: {
          targetclass: '@'
        },
        link: function (scope, element) {
          $(window).resize(function () {
            //console.log(scope.targetclass)
            $timeout(function () {
              var x = document.getElementsByClassName(scope.targetclass);
              var temp = 0;
              for (var i = 0; i < x.length; i++) {
                if (temp < x[i].offsetWidth) {
                  temp = x[i].offsetWidth;
                }
              }
              //console.log('maximo altura detectada', temp);
              element.css({minHeight: temp});
            }, 1000);
          }).resize();
        }
      };
    })
    //establece una altura personalizada partiendo del alto de pantalla o deua medida especifica
    .directive('customheight', function () {
      return {
        restrict: 'A',
        scope: {
          minus: '=',
          plus: '=',
          equal: '=',
          autoscroll: '='
        },
        link: function (scope, element) {
          $(window).resize(function () {
            var customHeight = $(window).height();
            if (scope.equal) {
              customHeight = scope.equal;
            }
            if (scope.minus) {
              customHeight -= scope.minus;
            }
            if (scope.plus) {
              customHeight += scope.plus;
            }
            if (scope.autoscroll == true) {
              element.css({maxHeight: customHeight});
              element.css({overflowY: 'scroll'});
            }
            element.css({minHeight: customHeight});
          }).resize();
        }
      };
    })

})();

'use strict';
angular
  .module('frontendApp')
  .controller('PressController', function (ContentService, ImageLoader, $window,  $log, $timeout, $rootScope, $scope) {
    var vm = this;
    $log.debug('PressController');
    //PRESS SECTION
    $rootScope.blogForm = {
      isOpen:false,
      isChanged:false,
      filterBy:'',
      params: {
        per_page:8,
        page:1,
        orderBy:{
          field:'date',
          dir:'desc'
        },
        filters:{
          source:{
            operator:'whereIn',
            value:''
          },
          date:{
            operator:'like',
            value:''
          },
          title:{
            operator:'like',
            value:''
          }
        }
      }
    };

    $rootScope.pickFilter= function(opt){
      opt.selected = opt.selected ? false:true;
      $rootScope.blogForm.isChanged = true;
      if($rootScope.blogForm.filterBy=='blogYears'){
        angular.forEach($rootScope.wc[$rootScope.blogForm.filterBy],function(i){
          if(i != opt){
            i.selected = false;
          }
        });
        $rootScope.blogForm.params.filters.date.value = opt.opt;
      }
      if($rootScope.blogForm.filterBy=='blogSources'){
        $rootScope.blogForm.params.filters.source.value="";
        var temp = [];
        angular.forEach($rootScope.wc[$rootScope.blogForm.filterBy],function(i){
          if(i.selected == true){
            if(temp.indexOf(i.opt)==-1){
              temp.push(i.opt);
              $rootScope.blogForm.params.filters.source.value+= i.opt+",";
            }
          }
        });
      }
      //console.log('select opt', opt, $rootScope.blogForm);
    };
    $rootScope.openBlogForm = function(value){
      $rootScope.blogForm.isOpen = value ? value : !$rootScope.blogForm.isOpen;
      $rootScope.blogForm.filterBy = 'blogSources';
      //console.log('openBlogForm', value, $rootScope.blogForm);
      if($rootScope.blogForm.isOpen == true){
        //console.log(' case 1');
        $rootScope.blogForm.params.filters2 = angular.copy($rootScope.blogForm.params.filters);
        $rootScope.wc2= angular.copy($rootScope.wc);
      }
      if( $rootScope.blogForm.isOpen == false) {
        //console.log(' case 2');
        $rootScope.blogForm.params.filters = $rootScope.blogForm.params.filters2;
        $rootScope.wc = angular.copy($rootScope.wc2);
      }
    };


    $rootScope.loadBlog = function(reload){
      if(reload) {
        $rootScope.blogForm.isOpen = false;
        $rootScope.blogForm.params.page = 1;
        $rootScope.blogForm.isChanged = false;
      }
      ContentService.getdata('webblog', $rootScope.blogForm.params)
        .success(function (res) {
          //console.log('webblog',res);
          $rootScope.wc.Webblog = res.result;
        });
    };
    $rootScope.$watch( 'blogForm', function(){
      //console.log('cambios',$rootScope.blogForm);
    }, true );

    $rootScope.changePage = function ( value) {
      switch(value) {
        case 'increase':
          $rootScope.blogForm.params.page++;
          break;
        case 'decrease':
          $rootScope.blogForm.params.page--;
          break;
        default:
          $rootScope.blogForm.params.page = value;
          break;
      }
      /*$rootScope[$scope.modelName].filters.page = angular.copy($scope.filters.page);*/
      $rootScope.loadBlog();
    };

    /////////PRESS KIT
    $rootScope.pickPressItem = function(value){
      //console.log(value);
      $rootScope.pressKitSelected = value;
    };

  });

'use strict';
angular
  .module('frontendApp')
  .controller('HomeController', function (ContentService, ImageLoader, $window, $log, $timeout, $rootScope, $scope) {
    var vm = this;
    $log.debug('HomeController');

    $rootScope.gCar = {
      items: [],
      current : 0,
      dir : ''
    };
    $rootScope.gSwitchSlide = function (value) {
      $rootScope.gCar.dir = value;
      $rootScope.gCar.old = angular.copy($rootScope.gCar.current);
      switch(value){
        case 'prev':
          if($rootScope.gCar.current>=1){
            $rootScope.gCar.current--;
          }
          else{
            $rootScope.gCar.current = $rootScope.gCar.items.length-1;
          }
          break;
        case 'next':
          if($rootScope.gCar.current < $rootScope.gCar.items.length-1){
            $rootScope.gCar.current++;
          }
          else{
            $rootScope.gCar.current = 0
          }
          break;
      }
      $rootScope.gCar.items[$rootScope.gCar.current].status='enter';
      $rootScope.gCar.items[$rootScope.gCar.old].status='leave';
      console.log('$rootScope.gCar',$rootScope.gCar);
      $timeout(function () {
        console.log('activado');
        $rootScope.lapsus = true;
      }, 1000);
    };
    $rootScope.startgCar=function(items){
      $rootScope.gCar.items = items;
      angular.forEach(items, function(value, key){
        value.status='leave';
        if(key == 0){
          value.status = 'enter';
        }
      });
      console.log(  $rootScope.gCar.items );
    };

    $rootScope.$watch('wc', function () {
      console.log('wc !!!',$rootScope.wc );
      if($rootScope.wc && $rootScope.wc.Webhomecarousel){
        $rootScope.startgCar($rootScope.wc.Webhomecarousel);
      }
    });
    $rootScope.lapsus = true;
    angular.element($window).bind('mousewheel', function (e) {
      console.log('SCROLL!!!', e);
      var way = '';
      if (e) {
        if (e.preventDefault) {
          e.preventDefault();
        }
        if (e.originalEvent.wheelDelta >= 0) {
          way = 'prev';
          console.log('Scroll up');
        }
        else {
          way = 'next';
          console.log('Scroll down');
        }
        e.returnValue = false;
        if ($rootScope.lapsus) {
          $rootScope.lapsus = false;
          $rootScope.gSwitchSlide (way);
        }
      }
    });

    $rootScope.carouselRedirect = function(id){
      switch(id){
        case 1:
          $rootScope.stateGo('services');
              break;
        case 2:
          $rootScope.stateGo('menu');
              break;
        case 3:
          $rootScope.stateGo('us');
              break;
        case 4:
          $rootScope.stateGo('I-D');
              break;
        case 5:
          $rootScope.stateGo('press');
              break;
      }
    }

  });

'use strict';
angular
  .module('frontendApp')
  .controller('ContactController', function (ContentService, ImageLoader, $window, $log, $timeout, $rootScope, $scope) {
    var vm = this;
    $log.debug('ContactController');
    $rootScope.isopen = false;


  });

'use strict';
angular
  .module('frontendApp')
  .controller('AppController', function ($log, ContentService,$location, $window,$anchorScroll,
                                         $rootScope, $timeout, localStorageService) {
    var vm = this;
    $log.debug('AppController');
    $rootScope.fadeAnimation = false;
    //Contenido fijo
    ContentService.fixedcontent().success(function (res) {
      $rootScope.fixedcontent = res;
      console.log('Contenidos fijos', $rootScope.fixedcontent)
    });
    $rootScope.getFixedContent = function(i){
      return $rootScope.fixedcontent ? $rootScope.fixedcontent[i][$rootScope.language] : '';
    };

    $rootScope.scrollTo = function(id) {
      $location.hash(id);
      $anchorScroll();
    };

    /////////////MODALS AND WEB FORMS///////////////

    $rootScope.pickArea = function(value){
      $rootScope.formData.area = value;
      console.log( 'formData', $rootScope.formData );
    };

    $rootScope.rharea = [
      {
        es: 'Área de interes',
        en: 'Area of interest'
      },
      {
        es: 'Prácticas profesionales',
        en: 'Professional Practices'
      },
      {
        es: 'Oportunidades laborales',
        en: 'Career Opportunities'
      }
    ];
    $rootScope.modals = {
      currentModal:''
    };
    $rootScope.modalTab = 1 ;
    $rootScope.showModal = function (modal, value){
      console.log(modal);
      $rootScope.currentModal = modal;
      $rootScope.modals.currentModal = 'app/views/modals/'+modal+'.html';
      $rootScope.modalTab = 1 ;
      $rootScope.formData = {};
     // $("html, body").animate({scrollTop: 0}, 1000);
    };
    $rootScope.formDataHome = {};
    $rootScope.closeModal = function (){
      $rootScope.modals.currentModal = '';
      $rootScope.modalTab = 1 ;
    };

    $rootScope.navModals = function (value){
      switch(value){
        case 'prev':
          if($rootScope.modalTab>1){
            $rootScope.modalTab--;
          }
          break;
        case 'next':
          $rootScope.modalTab++;
          $timeout(function () {
            if($rootScope.currentModal!='modalpresskit' ){
              $rootScope.closeModal();
            }
          }, 5000);
          break;
        default:
          $rootScope.modalTab = value;
          break;
      }
    };

    $rootScope.$watch('modals', function () {
      console.log('actualiza modals',$rootScope.modals )
    }, true);

    $rootScope.sendForm = function (id, data, flash){
      if(id && data){
        /*if(id==5){
          data.products = '';
          angular.forEach($rootScope.cart,function(i){
            data.products = data.products+'<br>PROD: '+i.nombre+' CANT:'+ i.quantity;
          })
        }
        var params = {
          mailingcategory_id:id,
          fields: data
        };
        console.log('ingresa', params);
        ContentService.sendform(params)
          .success(function (res) {
            if (res.status) {
              $rootScope.navModals('next');
              console.log('sendform', res)
            }
          });*/
      }
      else{
        $rootScope.navModals('next');
      }
      if(flash){
        toastr.success($rootScope.switchText('Mensaje enviado', 'Message sent'), 'Success');
      }

    };

    //ENLACE DE RESERVAS
    $rootScope.reservationsLink = 'https://gustu.dinesuperb.com/reserve/experience';

    //GALLERY SECTION
    $rootScope.pickGallery = function(value, index){
      $rootScope.gGallery= value;
      angular.forEach($rootScope.gGallery, function(i){
        if(i.image){
          i.imageUrl = $rootScope.api+i.image
        }
        else{
          i.imageUrl = "/assets/images/placeholder.jpg";
        }
      });
      $rootScope.gGalleryConf= {
        items: 1,
        nav:true,
        startPosition:parseInt(index),
        loop:true,
        autoplay: false,
        autoPlaySpeed: 5000,
        autoPlayTimeout: 5000,
        autoplayHoverPause: true,
        navText : ['<span><i class="fas fa-chevron-up"></i></span>','<span><i class="fas fa-chevron-down"></i></span>'],
      };
    };

    //US SECTION
    $rootScope.pickMember = function(value){
      $rootScope.gMember = value;
    };

    // BACKGROUND IMAGE
    $rootScope.imageBackground = function(value){
      var temp = {};
      if (value.image){
        var url = encodeURI($rootScope.api+value.image);
        temp = {backgroundImage: 'url('+url+')'};
      }
      else{
        temp = {background: 'url("../assets/images/placeholder.jpg")'};
      }


      return temp;
    };

    /////////////MAP COORDINATES/////////////////
    $rootScope.agency = {
      latitud:'-16.544510',
      longitud:'-68.086447'
    };


    //HOME
    $rootScope.homeC= {
      items: 1,
      nav:true,
      startPosition:0,
      loop:true,
      autoplay: false,
      autoPlaySpeed: 5000,
      autoPlayTimeout: 5000,
      autoplayHoverPause: true,
      animateIn: 'slideInUp', // add this
      animateOut: 'slideOutUp', // and this
      navText : ['<span><i class="fas fa-chevron-up"></i></span>','<span><i class="fas fa-chevron-down"></i></span>'],
    };
    var owlAPi;
    $rootScope.ready = function ($api) {
      owlAPi = $api;
    };
    $rootScope.next = function(){
      console.dir('next', owlAPi);
      owlAPi.trigger('next.owl.carousel',[2000]);
    };
    $rootScope.prev = function(){
      console.dir('prev', owlAPi);
      owlAPi.trigger('prev.owl.carousel',[2000]);
    };
    $rootScope.changeSlide = function (direction) {
      switch (direction) {
        case 'next':
          $rootScope.next();
          break;
        case 'prev':
          $rootScope.prev();
          break;
      }
      $timeout(function () {
        console.log('activado');
        $rootScope.lapsus = true;
      }, 1000);
    };



  });

(function() {
  'use strict';

  angular
      .module('frontendApp')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creation" is avaible by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($timeout, webDevTec, toastr) {
    var vm = this;

    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1516719002839;
    vm.showToastr = showToastr;

    activate();

    function activate() {
      getWebDevTec();
      $timeout(function() {
        vm.classAnimation = 'rubberBand';
      }, 4000);
    }

    function showToastr() {
      toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
      vm.classAnimation = '';
    }

    function getWebDevTec() {
      vm.awesomeThings = webDevTec.getTec();

      angular.forEach(vm.awesomeThings, function(awesomeThing) {
        awesomeThing.rank = Math.random();
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('frontendApp')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $state, ContentService,
                    ImageLoader,
                    $anchorScroll, $location,
                    localStorageService, $timeout, $window, $stateParams) {

    //REST API ROUTE
    //$rootScope.api = 'http://localhost:8000';
    $rootScope.api = 'http://dev-gustu-admin.aknatechnologies.com/restapi/public';

    //SESSION VARS MANIPULATION
    $rootScope.getSessionParam = function (key) {
      return localStorageService.get(key);
    };

    console.log('MARK STATE PARAMS', $stateParams.lan),

    $rootScope.setSessionParam = function (key, val) {
      return localStorageService.set(key, val);
    };
    // SETTING SPANISH AS DEFAULT LANGUAGE
    if($stateParams.lan == 'es' || $stateParams.lan == 'en') {
      $rootScope.language = $stateParams.lan;
    }
    else{
      $rootScope.language = 'es';
     // $state.go('home', {lan: 'es'}, {reload: true});
    }
    //VERIFY CURRENT LANGUAGE
    $timeout(function(){
      if ($stateParams.lan == 'es' || $stateParams.lan == 'en') {
        $rootScope.changeLanguage($stateParams.lan, $rootScope.currentState);
      }
      else{
        $rootScope.language = 'es';
        //$state.go('home', {lan: 'es'}, {reload: true});
      }
    }, 2);
    //TRANSALATE
    $rootScope.translate = function (target) {
      return target[$rootScope.language];
    };

    $rootScope.switchText = function (value1, value2) {
      if ($rootScope.language == 'es') {
        return value1;
      }
      else {
        return value2;
      }
    };

    //CHANGE OF ROUTE SETTING A NEW LANGUAGE
    $rootScope.changeLanguage = function (value, state) {
      $rootScope.language = value;
      $rootScope.setSessionParam('language', value);
      $state.go(state, {lan: value});
    };

    //MAIL TO FUNCTION
    $rootScope.sendMail = function (emailId, subject, message) {
      $window.open("mailto:" + emailId + "?subject=" + subject + "&body=" + message, "_self");
    };

    //EXECUTE ON ROUTE CHANGE
    $rootScope.getCurrentSection = function(search){
     // console.log('buscando seccion actual');
      angular.forEach($rootScope.wc.Webroute, function(i){
        if(i.state == search){
          $rootScope.currentSections = i.webgsection;
        }
      });
      console.log('actual', $rootScope.currentSections );
    };

    //GUSTU THEME BY DEFAULT
    $rootScope.gustuTheme = 'theme-1';
    $rootScope.gustuThemeColor = '#D7AF99';

    //MENU HEADER
    $rootScope.menu = false;

    $rootScope.showMenu = function (value) {
      $rootScope.menu = value ? value : !$rootScope.menu;
      if($rootScope.menu === false){
        $rootScope.subMenu = false;
        angular.forEach($rootScope.menuList, function(i){
            i.isOpen = false;
        });
      }
    };
    $rootScope.menuList = [
      {isOpen:false,label:{es:'Inicio',en:'Home'},state:'home',url:''},
      {isOpen:false,label:{es:'Menu',en:'Menu'},state:'menu',url:'menu'},
      {isOpen:false,label:{es:'Nosotros',en:'Us'},state:'us',url:'us'},
      {isOpen:false,label:{es:'Servicios',en:'Services'},state:'services',url:'services'},
      {isOpen:false,label:{es:'I+D',en:'I+D'},state:'I-D',url:'I-D'},
      {isOpen:false,label:{es:'Prensa',en:'Press'},state:'press',url:'press'},
      {isOpen:false,label:{es:'Contactos',en:'Contact'},state:'contact',url:'contact'},
    ];
    $rootScope.constructMenu = function(){
      angular.forEach($rootScope.menuList,function(item){
        angular.forEach($rootScope.wc.Webroute,function(sub){
          if(sub.state == item.state){
            $rootScope.loadSubMenu(item, sub);
          }
        });
      });
    };
    $rootScope.loadSubMenu = function (target, source) {
      target.sections = [];
      angular.forEach(source.webgsection, function (sec) {
        target.sections.push({
          label: sec.title,
          id:'sec' + sec.id
        });
      });
      if(source.name == 'I-D'){
        target.sections.push({
          label: {es: "Gustu Blog", en: "Gustu Blog"},
          id:'none',
          link: 'http://blog.gustu.bo/',
        });
      }
    };
    $rootScope.subMenu = false;
    $rootScope.openSubMenu = function (item, value){
      $rootScope.subMenu = value ? value : !$rootScope.subMenu;
      angular.forEach($rootScope.menuList, function(i){
        if (i.state == item.state){
          i.isOpen = value;
        }
        else{
          i.isOpen = false;
        }
      });
    };
    $rootScope.encodeName = function (value){
      return encodeURI(value);
    };

    //CHANGE ROUTE
    $rootScope.stateGo = function(state, sec){
      $state.go(state, {
          lan: $rootScope.language,
          sec: sec?sec:null
        }
      );
      $rootScope.showMenu(false);
      $rootScope.scroller();
    };

    $rootScope.scroller = function (){
      if( $stateParams.sec && $rootScope.wc) {
        $timeout(function(){
          console.log('SCROLLER TO', $stateParams.sec );
          $("html, body")
            //.delay(1000)
            .animate({scrollTop: $('#'+$stateParams.sec).offset().top }, 1000);
        }, 1500);
      }
      if( !$stateParams.sec && $rootScope.wc) {
        console.log(' SCROLLER TO TOP', $stateParams.sec  );
        $("html, body").animate({scrollTop: 0}, 500);
      }
    };

    $rootScope.getImageArray = function (source, target) {
      var imageArray = [];
      angular.forEach(source, function (value, key) {
        if (value[target]) {
          imageArray.push($rootScope.api+ value[target]);
        }
      });
      return imageArray;
    };

    //AUTO EXECUTE ON ROUTE CHANGE OR LOAD
    $rootScope.$on('$stateChangeSuccess', function (event, toState) {

      $state.current = toState;
      $rootScope.$state = $state;
      $rootScope.menu = false;
      $rootScope.currentState = $state.current.name;
      if($stateParams.lan == 'es' || $stateParams.lan == 'en') {
        $rootScope.language = $stateParams.lan;
      }
      else{
        $rootScope.language = 'es';
      }
      $rootScope.showLoader=true;
      /*if($rootScope.currentState == 'home'){
        $rootScope.showLoader=true;
      }
      else{
        $rootScope.showLoader=false;
      }*/

      //GET RESTAPI CONTENTS
      ContentService.webcontent($rootScope.currentState)
        .success(function (res) {
          if(res.status){
            $rootScope.wc = res.result;
            console.log('webcontent', res, res.result.data);
            //SET CURRENT THEME
            /*
            $theme1: #D7AF99;
            $theme2: #9FAD70;
            $theme3: #ACB6C2;
            */
            switch($rootScope.wc.Webconfig[0].value){
              case "1":
                $rootScope.gustuTheme = 'theme-1';
                $rootScope.gustuThemeColor = '#D7AF99';
                    break;
              case "2":
                $rootScope.gustuTheme = 'theme-2';
                $rootScope.gustuThemeColor = '#9FAD70';
                    break;
              case "3":
                $rootScope.gustuTheme = 'theme-3';
                $rootScope.gustuThemeColor = '#ACB6C2';
                    break;
            }
            //GET CURRENT SECTION TO RENDER IN MAIN-TEMPLATE
            $rootScope.getCurrentSection($rootScope.currentState);
            //GET CONTACT DATA
            $rootScope.contactData =  $rootScope.wc.Webroute[6].webcontent;
            console.log('$rootScope.contactData',  $rootScope.contactData);
            //CONSTRUCT SUB MENUS LIST
            $rootScope.constructMenu();
            //AUTOMATIC SCROLL BEFORE WEB CONTENTS IS LOADED
            $rootScope.scroller();
            if($rootScope.currentState != 'home'){
              $timeout(function(){
                $rootScope.showLoader = false;
              }, 500);
            }
            //LOADER
            var imageArray = $rootScope.getImageArray($rootScope.wc.Webhomecarousel, 'image');
            ImageLoader.loadImages(imageArray).then(function (loadedStrings) {
              $rootScope.imageStringsList = loadedStrings;
              console.log($rootScope.imageStringsList);
              new WOW().init();
              $rootScope.showLoader = false;
            });

          }
        });
      //GET CURRENT LANGUAGE
      ($rootScope.getSessionParam('language')) ?
        $rootScope.language = $rootScope.getSessionParam('language') : $rootScope.language = 'es';
    });


  }

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('home', {
        url: '/:lan',
        templateUrl: 'app/views/home.html',
        controller: 'HomeController',
        controllerAs: 'ini'
      })
      .state('menu', {
        url: '/:lan/menu/:sec',
        templateUrl: 'app/views/main-template.html',
      })
      .state('us', {
        url: '/:lan/us/:sec',
        templateUrl: 'app/views/main-template.html',
      })
      .state('services', {
        url: '/:lan/services/:sec',
        templateUrl: 'app/views/main-template.html',
      })
      .state('I-D', {
        url: '/:lan/I-D/:sec',
        templateUrl: 'app/views/main-template.html',
      })
      .state('press', {
        url: '/:lan/press/:sec',
        controller:'PressController',
        templateUrl: 'app/views/main-template.html',
      })
      .state('contact', {
        url: '/:lan/contact/:sec',
        controller:'ContactController',
        templateUrl: 'app/views/main-template.html',
      })

    $urlRouterProvider.otherwise('/es');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('frontendApp')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $locationProvider) {
    // Enable log
    $logProvider.debugEnabled(true);
    $locationProvider.html5Mode(true).hashPrefix('#');

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;

    //initialize wow library
    new WOW().init();
  }

})();

angular.module("frontendApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=\"container\"><div><acme-navbar creation-date=\"main.creationDate\"></acme-navbar></div><div class=\"jumbotron text-center\"><h1>\'Allo, \'Allo!</h1><p class=\"lead\"><img src=\"assets/images/yeoman.png\" alt=\"I\'m Yeoman\"><br>Always a pleasure scaffolding your apps.</p><p class=\"animated infinite\" ng-class=\"main.classAnimation\"><button type=\"button\" class=\"btn btn-lg btn-success\" ng-click=\"main.showToastr()\">Splendid Toastr</button></p><p>With ♥ thanks to the contributions of<acme-malarkey extra-values=\"[\'Yeoman\', \'Gulp\', \'Angular\']\"></acme-malarkey></p></div><div class=\"row\"><div class=\"col-sm-6 col-md-4\" ng-repeat=\"awesomeThing in main.awesomeThings | orderBy:\'rank\'\"><div class=\"thumbnail\"><img class=\"pull-right\" ng-src=\"assets/images/{{ awesomeThing.logo }}\" alt=\"{{ awesomeThing.title }}\"><div class=\"caption\"><h3>{{ awesomeThing.title }}</h3><p>{{ awesomeThing.description }}</p><p><a ng-href=\"{{awesomeThing.url}}\">{{ awesomeThing.url }}</a></p></div></div></div></div></div>");
$templateCache.put("app/views/footer.html","<div class=\"container-fluid footer-wrapper\" data-ng-if=\"$root.wc\" data-ng-class=\"{\'white\':$root.currentState == \'home\',\'black\':$root.currentState != \'home\'}\"><div class=\"footer-box\" data-ng-if=\"$root.currentState != \'home\'\"><div class=\"footer-center\"><ul><li data-ng-bind-html=\"$root.translate($root.contactData[9].content)\"></li><li data-ng-bind-html=\"$root.translate($root.contactData[10].content)\"></li><li data-ng-bind-html=\"$root.translate($root.contactData[11].content)\"></li></ul></div></div><div class=\"footer-box\"><div class=\"footer-left\"><a target=\"_blank\" href=\"{{$root.wc.Websocial[0].url}}\" class=\"footer-icon\"><i class=\"fab fa-facebook-f\"></i></a> <a target=\"_blank\" href=\"{{$root.wc.Websocial[1].url}}\" class=\"footer-icon\"><i class=\"fab fa-instagram\"></i></a> <a target=\"_blank\" href=\"{{$root.wc.Websocial[2].url}}\" class=\"footer-icon\"><i class=\"fab fa-twitter\"></i></a> <a target=\"_blank\" href=\"{{$root.wc.Websocial[3].url}}\" class=\"footer-icon\"><i class=\"fab fa-youtube\"></i></a></div><div class=\"footer-right\"><a target=\"_blank\" href=\"{{$root.translate($root.contactData[0].content)}}\" class=\"footer-link\">BLOG</a> <a target=\"_blank\" href=\"{{$root.translate($root.contactData[1].content)}}\" class=\"footer-link\">Q\'ATU</a> <a target=\"_blank\" href=\"{{$root.translate($root.contactData[2].content)}}\" class=\"footer-link\">MELTING POT</a></div></div></div>");
$templateCache.put("app/views/header.html","<div class=\"container-fluid header-wrapper\"><div class=\"header-box\"><div class=\"header-items\"><img src=\"../assets/images/marca-02-a.png\" alt=\"\" data-ng-class=\"{\'auto-hide\':$root.menu}\" class=\"brand\"> <a class=\"header-option lan\" data-ng-class=\"{\'open\':$root.lanOpen, \'show-xs\':$root.menu}\" data-ng-init=\"$root.lanOpen = false\">{{$root.language}} <i class=\"fas fa-chevron-down\" data-ng-click=\"$root.lanOpen=!$root.lanOpen\"></i><div class=\"opt-lan\" data-ng-if=\"$root.lanOpen\"><span data-ng-show=\"$root.language ==\'en\'\" data-ng-click=\"$root.changeLanguage(\'es\',$root.currentState)\">Es</span> <span data-ng-show=\"$root.language ==\'es\'\" data-ng-click=\"$root.changeLanguage(\'en\',$root.currentState)\">En</span></div></a> <a href=\"\" ui-sref=\"contact({lan:$root.language})\" class=\"header-option hidden-xs\">{{$root.switchText(\'Contacto\',\'Contact\')}}</a> <a href=\"{{$root.reservationsLink}}\" target=\"_blank\" class=\"header-option t2 {{$root.gustuTheme}}\" data-ng-class=\"{\'show-xs\':$root.menu}\">{{$root.switchText(\'Reservas\',\'Reservations\')}}</a> <a href=\"\" class=\"header-option burguer\" data-ng-click=\"$root.showMenu()\"><img data-ng-show=\"!menu\" src=\"../assets/images/icons/menu-01.png\" alt=\"\"> <img data-ng-show=\"menu\" src=\"../assets/images/icons/menu-cerrar01@2x.png\"></a></div><div data-ng-if=\"$root.menu\" class=\"list-wrapper\" windowheight=\"\"><ul class=\"header-list\"><li class=\"level1\" data-ng-repeat=\"item in $root.menuList\"><a href=\"\" data-ng-class=\"{\'active\':(!$root.subMenu || $root.subMenu && item.isOpen )}\" data-ng-click=\"(item.sections.length>1)?$root.openSubMenu(item,!item.isOpen):$root.stateGo(item.state)\">{{$root.translate(item.label)}}</a> <i data-ng-click=\"$root.openSubMenu(item, true)\" data-ng-class=\"{\'active\':(!$root.subMenu || $root.subMenu && item.isOpen )}\" data-ng-if=\"item.sections.length>1 && !item.isOpen\" class=\"fas fa-chevron-down\"></i> <i data-ng-click=\"$root.openSubMenu(item, false)\" data-ng-class=\"{\'active\':(!$root.subMenu || $root.subMenu && item.isOpen )}\" data-ng-if=\"item.sections.length>1 && item.isOpen\" class=\"fas fa-chevron-up\"></i><ul data-ng-show=\"item.isOpen\"><li data-ng-repeat=\"sec in item.sections\" class=\"level2\"><a data-ng-class=\"{\'active\':$root.subMenu}\" data-ng-if=\"!sec.link\" data-ng-click=\"$root.stateGo(item.url,sec.id);\">{{$root.translate(sec.label)}}</a> <a data-ng-class=\"{\'active\':$root.subMenu}\" data-ng-if=\"sec.link\" target=\"{{((sec.link)?\'_blank\':\'_self\')}}\" href=\"{{ (sec.link) ? sec.link :( $root.language+\'/\'+item.url+\'#\'+sec.id )}}\">{{$root.translate(sec.label)}}</a></li></ul></li></ul><div class=\"header-extra hidden-sm hidden-md hidden-lg\"><div class=\"extra-row\"><a target=\"_blank\" href=\"{{$root.wc.Websocial[0].url}}\" class=\"footer-icon\"><i class=\"fab fa-facebook-f\"></i></a> <a target=\"_blank\" href=\"{{$root.wc.Websocial[1].url}}\" class=\"footer-icon\"><i class=\"fab fa-instagram\"></i></a> <a target=\"_blank\" href=\"{{$root.wc.Websocial[2].url}}\" class=\"footer-icon\"><i class=\"fab fa-twitter\"></i></a> <a target=\"_blank\" href=\"{{$root.wc.Websocial[3].url}}\" class=\"footer-icon\"><i class=\"fab fa-youtube\"></i></a></div><div class=\"extra-row\"><a target=\"_blank\" href=\"{{$root.translate($root.contactData[0].content)}}\" class=\"footer-link\">BLOG</a> <a target=\"_blank\" href=\"{{$root.translate($root.contactData[1].content)}}\" class=\"footer-link\">Q\'ATU</a> <a target=\"_blank\" href=\"{{$root.translate($root.contactData[2].content)}}\" class=\"footer-link\">MELTING POT</a></div></div></div></div></div>");
$templateCache.put("app/views/home.html","<header data-ng-include=\"\" data-src=\"\'app/views/header.html\'\"></header><header data-ng-if=\"$root.showLoader\" data-ng-include=\"\" data-src=\"\'app/views/loader.html\'\"></header><div data-ng-if=\"$root.wc\" class=\"container-fluid home\"><div class=\"slider-wrapper\"><div class=\"carousel sliderhome\" windowheight=\"\" data-ng-class=\"{ \'active\':i.status==\'enter\', \'animated\': $index == $root.gCar.current || $index == $root.gCar.old , \'visible\': $index == $root.gCar.current || $index == $root.gCar.old , \'slideInUp\':i.status==\'enter\' && $root.gCar.dir==\'next\' , \'slideOutUp\':i.status==\'leave\' && $root.gCar.dir==\'next\' , \'slideInDown\':i.status==\'enter\' && $root.gCar.dir==\'prev\' , \'slideOutDown\':i.status==\'leave\' && $root.gCar.dir==\'prev\' , }\" ng-swipe-up=\"$root.gSwitchSlide(\'next\')\" ng-swipe-down=\"$root.gSwitchSlide(\'prev\')\" data-ng-style=\"{\'background\': \'url(\' + $root.api+i.image + \')\'}\" data-ng-repeat=\"i in $root.gCar.items\"><div class=\"slider-content\"><small class=\"slider-counter {{$root.gustuTheme}}\">{{$index + 1}}/{{$root.wc.Webhomecarousel.length}}</small><h1 class=\"slider-title\">{{$root.translate(i.title)}}</h1><p class=\"slider-text\">{{$root.translate(i.content)}}</p><a class=\"link-animated {{$root.gustuTheme}}\" style=\"cursor: pointer;\" data-ng-click=\"$root.carouselRedirect(i.id)\"><span class=\"line {{$root.gustuTheme}}\"></span> {{$root.switchText(\'Ver más\', \'View more\')}}</a></div></div><div class=\"carousel-nav\"><a href=\"\" class=\"nav-arrow nav-next\" data-ng-click=\"$root.gSwitchSlide(\'prev\')\"><span><i class=\"fas fa-chevron-up\"></i></span></a> <a href=\"\" class=\"nav-arrow nav-prev\" data-ng-click=\"$root.gSwitchSlide(\'next\')\"><span><i class=\"fas fa-chevron-down\"></i></span></a></div></div></div><footer data-ng-include=\"\" data-src=\"\'app/views/footer.html\'\"></footer>");
$templateCache.put("app/views/loader.html","<div class=\"container-fluid loader-wrapper\" data-ng-if=\"$root.showLoader\" customheight=\"\"><div class=\"loader\" customheight=\"\"><div class=\"logo\"></div><div class=\"progress\"><div class=\"line\" data-ng-class=\"{\'complete\':!showLoader}\"></div></div></div></div>");
$templateCache.put("app/views/main-template.html","<header data-ng-include=\"\" data-src=\"\'app/views/header.html\'\"></header><header data-ng-include=\"\" data-src=\"\'app/views/loader.html\'\"></header><div data-ng-if=\"$root.wc\" class=\"container-fluid content-general\" customheight=\"\" minus=\"110\"><div class=\"content-wrapper\" data-ng-repeat=\"sec in $root.currentSections\"><div class=\"col-xs-12\" style=\"height: 1px;background: transparent\" id=\"{{\'sec\'+sec.id}}\"></div><div class=\"cont-header\" data-ng-style=\"{\'background\': \'url(\' + $root.api+sec.image + \')\'}\"><div class=\"cont-title-1 {{$root.gustuTheme}}\" data-in-view=\"$root[\'draw\'+$index] = $inview\" data-ng-class=\"{ draw: $root[\'draw\'+$index] }\"><h2>{{translate(sec.title)}}</h2></div></div><div class=\"cont-text center wow fadeIn\" data-ng-if=\"translate(sec.content)\" data-ng-bind-html=\"translate(sec.content)\"></div><div class=\"subsection\" data-ng-repeat=\"sub in sec.webgsubsection\"><h3 class=\"cont-title-2 wow fadeIn\" data-ng-if=\"translate(sub.title)\">{{translate(sub.title)}}</h3><div class=\"cont-header-2 wow fadeIn\" data-ng-if=\"sub.image\" data-ng-style=\"{\'background\': \'url(\' + $root.api+sub.image + \')\'}\"></div><div class=\"cont-text\" data-ng-if=\"sub.content\" data-ng-bind-html=\"translate(sub.content)\"></div><div class=\"cont-text center m-auto wow fadeIn\" data-ng-if=\"sub.file || sub.link\"><a href=\"{{$root.api+sub.file}}\" target=\"_blank\" data-ng-if=\"sub.file && sec.type!=\'webpresskit\'\" class=\"btn btn-theme {{$root.gustuTheme}}\">{{$root.translate(sub.file_label)}}</a> <a href=\"{{sub.link}}\" target=\"_blank\" data-ng-if=\"sub.link && sec.type!=\'webpresskit\'\" class=\"btn btn-theme\">{{$root.translate(sub.link_label)}}</a><a data-ng-click=\"$root.showModal(\'modalpresskit\');$root.pickPressItem(sub)\" data-ng-if=\"sub.file && sec.type==\'webpresskit\'\" class=\"btn btn-theme {{$root.gustuTheme}}\">{{$root.translate(sub.file_label)}}</a> <a data-ng-if=\"sub.link && sec.type==\'webpresskit\'\" data-ng-click=\"$root.showModal(\'modalpress\')\" class=\"btn btn-theme\">{{$root.translate(sub.link_label)}}</a></div><div class=\"cont-gallery wow fadeIn\" data-ng-if=\"sub.webgsubsectiongallery.length>0\"><div class=\"cont-photo\" data-ng-repeat=\"item in sub.webgsubsectiongallery\"><div class=\"photo\" data-ng-click=\"$root.showModal(\'modalgallery\'); $root.pickGallery(sub.webgsubsectiongallery,$index)\" data-ng-style=\"{\'background\': \'url(\' + $root.api+item.image + \')\'}\"><p class=\"expand\"><i class=\"fas fa-expand\"></i></p></div></div></div><div class=\"cont-playlist wow fadeIn\" data-ng-if=\"sub.webgsubsectionvideo.length>0\"><div class=\"cont-video\" data-ng-class=\"{\'full\':sub.webgsubsectionvideo.length==1}\" data-ng-repeat=\"vid in sub.webgsubsectionvideo\"><div class=\"video\" my-youtube=\"\" code=\"vid.link\"></div></div></div></div><ng-include data-ng-if=\"sec.type==\'webgfamily\'\" data-src=\"\'app/views/sections/family.html\'\"></ng-include><ng-include data-ng-if=\"sec.type==\'webblog\'\" data-src=\"\'app/views/sections/blog.html\'\"></ng-include><ng-include data-ng-if=\"sec.type==\'webpresskit\'\" data-src=\"\'app/views/sections/presskit.html\'\"></ng-include><ng-include data-ng-if=\"sec.type==\'contact\'\" data-src=\"\'app/views/sections/contact.html\'\"></ng-include></div></div><footer data-ng-include=\"\" data-src=\"\'app/views/footer.html\'\"></footer>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=\"container-fluid\"><div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"https://github.com/Swiip/generator-gulp-angular\"><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\"><ul class=\"nav navbar-nav\"><li class=\"active\"><a ng-href=\"#\">Home</a></li><li><a ng-href=\"#\">About</a></li><li><a ng-href=\"#\">Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");
$templateCache.put("app/views/modals/modalcatering.html","<div class=\"all-modal dark\"><div class=\"modal-center ta-center container-fluid modal-family\" customheight=\"\" autoscroll=\"true\"><div class=\"close-button\" data-ng-click=\"$root.closeModal()\"><i class=\"fas fa-times\"></i></div><div class=\"form-wrapper\" data-ng-if=\"$root.modalTab == 1\"><form action=\"\" data-ng-submit=\"$root.sendForm()\"><h3 class=\"form-title {{$root.gustuTheme}}\">{{$root.switchText(\'Catering\',\'Catering\')}}</h3><div class=\"input-row\"><input type=\"text\" required=\"\" placeholder=\"{{$root.switchText(\'Nombre\',\'Name\')}}\" data-ng-model=\"$root.form.name\" class=\"form-control\"></div><div class=\"input-row\"><input type=\"email\" required=\"\" placeholder=\"{{$root.switchText(\'Correo electrónico\',\'Email\')}}\" data-ng-model=\"$root.form.email\" class=\"form-control\"></div><div class=\"input-row\"><input type=\"text\" required=\"\" placeholder=\"{{$root.switchText(\'Tipo de evento\',\'Event type\')}}\" data-ng-model=\"$root.form.event\" class=\"form-control\"></div><div class=\"input-row\"><input type=\"date\" required=\"\" placeholder=\"{{$root.switchText(\'Fecha del evento\',\'Event date\')}}\" data-ng-model=\"$root.form.date\" class=\"form-control\"></div><div class=\"input-row\"><input type=\"text\" required=\"\" data-ng-class=\"{\'en\':$root.language == \'en\'}\" placeholder=\"{{$root.switchText(\'Cantidad de personas\',\'Persons\')}}\" data-ng-model=\"$root.form.persons\" class=\"form-control\"></div><div class=\"input-row\"><button class=\"btn-theme {{$root.gustuTheme}}\">{{$root.switchText(\'Enviar\',\'Send\')}}</button></div></form></div><div class=\"form-wrapper flex\" data-ng-if=\"$root.modalTab == 2\"><form action=\"\" data-ng-submit=\"$root.sendForm()\"><p class=\"form-help {{$root.gustuTheme}}\">{{$root.switchText(\'Gracias por escribirnos, nos pondremos en contacto lo antes posible.\', \'Thanks for writing, we will contact you as soon as possible.\')}}</p></form></div></div></div>");
$templateCache.put("app/views/modals/modalcontact.html","<div class=\"all-modal dark\"><div class=\"modal-center ta-center container-fluid modal-family\" customheight=\"\" autoscroll=\"true\"><div class=\"close-button\" data-ng-click=\"$root.closeModal()\"><i class=\"fas fa-times\"></i></div><div class=\"form-wrapper\"><form action=\"\"><h3 class=\"form-title {{$root.gustuTheme}}\">Lorem ipsum.</h3><div class=\"input-row\"><input type=\"text\" class=\"form-control\"></div><div class=\"input-row\"><input type=\"text\" class=\"form-control\"></div><div class=\"input-row\"><textarea name=\"\" class=\"form-control\"></textarea></div><div class=\"input-row\"><button class=\"btn-theme {{$root.gustuTheme}}\">{{$root.switchText(\'Enviar\',\'Send\')}}</button></div></form></div></div></div>");
$templateCache.put("app/views/modals/modalfamily.html","<div class=\"all-modal white\"><div class=\"modal-center ta-center container-fluid modal-family\" customheight=\"\" autoscroll=\"true\"><div class=\"modal-box\" style=\"margin-top: 50px\"><div class=\"member-header portrait\" data-ng-style=\"{\'background\': \'url(\' + $root.api+gMember.image + \')\'}\"></div><div class=\"member-header desc\"><p class=\"member-name\">{{gMember.name}}</p><p class=\"member-ocupation\">{{$root.translate(gMember.position)}}</p></div><div class=\"close-button-extra\" data-ng-click=\"$root.closeModal()\"><i class=\"fas fa-times\"></i></div></div><div class=\"modal-box\"><div class=\"member-bio\">{{$root.translate(gMember.content)}}</div></div></div></div>");
$templateCache.put("app/views/modals/modalgallery.html","<div class=\"all-modal dark\"><div class=\"modal-center ta-center container-fluid\" windowheight=\"\"><div class=\"close-button\" data-ng-click=\"$root.closeModal()\"><i class=\"fas fa-times\"></i></div><div class=\"modal-box\"><ng-owl-carousel windowheight=\"\" class=\"owl-theme gallery-wrapper\" owl-items=\"$root.gGallery\" owl-properties=\"$root.gGalleryConf\" owl-ready=\"$root.ready($api)\"><div class=\"gallery-item\" windowheight=\"\" data-ng-repeat=\"item in $root.gGallery\"><img src=\"{{ item.imageUrl }}\" alt=\"\"></div></ng-owl-carousel></div></div></div>");
$templateCache.put("app/views/modals/modalpress.html","<div class=\"all-modal dark\"><div class=\"modal-center ta-center container-fluid modal-family\" customheight=\"\" autoscroll=\"true\"><div class=\"close-button\" data-ng-click=\"$root.closeModal()\"><i class=\"fas fa-times\"></i></div><div class=\"form-wrapper\" data-ng-if=\"$root.modalTab == 1\"><form action=\"\" data-ng-submit=\"$root.sendForm()\"><h3 class=\"form-title {{$root.gustuTheme}}\">{{$root.switchText(\'Prensa y RRPP\',\'Press\')}}</h3><div class=\"input-row\"><input type=\"text\" required=\"\" placeholder=\"{{$root.switchText(\'Nombre\',\'Name\')}}\" data-ng-model=\"$root.form.name\" class=\"form-control\"></div><div class=\"input-row\"><input type=\"email\" required=\"\" placeholder=\"{{$root.switchText(\'Correo electrónico\',\'Email\')}}\" data-ng-model=\"$root.form.email\" class=\"form-control\"></div><div class=\"input-row\"><input type=\"text\" required=\"\" placeholder=\"{{$root.switchText(\'Empresa\',\'Enterprise\')}}\" data-ng-model=\"$root.form.enterprise\" class=\"form-control\"></div><div class=\"input-row\"><input type=\"text\" required=\"\" placeholder=\"{{$root.switchText(\'Lugar de origen\',\'City\')}}\" data-ng-model=\"$root.form.city\" class=\"form-control\"></div><div class=\"input-row\"><textarea name=\"\" required=\"\" placeholder=\"{{$root.switchText(\'Mensaje\',\'Message\')}}\" data-ng-model=\"$root.form.message\" class=\"form-control\"></textarea></div><div class=\"input-row\"><button class=\"btn-theme {{$root.gustuTheme}}\">{{$root.switchText(\'Enviar\',\'Send\')}}</button></div></form></div><div class=\"form-wrapper flex\" data-ng-if=\"$root.modalTab == 2\"><form action=\"\" data-ng-submit=\"$root.sendForm()\"><p class=\"form-help {{$root.gustuTheme}}\">{{$root.switchText(\'Gracias por escribirnos, nos pondremos en contacto lo antes posible.\', \'Thanks for writing, we will contact you as soon as possible.\')}}</p></form></div></div></div>");
$templateCache.put("app/views/modals/modalpresskit.html","<div class=\"all-modal dark\"><div class=\"modal-center ta-center container-fluid modal-family\" customheight=\"\" autoscroll=\"true\"><div class=\"close-button\" data-ng-click=\"$root.closeModal()\"><i class=\"fas fa-times\"></i></div><div class=\"form-wrapper\" data-ng-if=\"$root.modalTab == 1\"><form action=\"\" data-ng-submit=\"$root.sendForm()\"><h3 class=\"form-title {{$root.gustuTheme}}\">{{$root.switchText(\'Press Kit\',\'Press Kit\')}}</h3><div class=\"input-row\"><input type=\"text\" required=\"\" placeholder=\"{{$root.switchText(\'Nombre\',\'Name\')}}\" data-ng-model=\"$root.form.name\" class=\"form-control\"></div><div class=\"input-row\"><input type=\"email\" required=\"\" placeholder=\"{{$root.switchText(\'Correo electrónico\',\'Email\')}}\" data-ng-model=\"$root.form.email\" class=\"form-control\"></div><div class=\"input-row\"><input type=\"text\" required=\"\" placeholder=\"{{$root.switchText(\'Empresa\',\'Enterprise\')}}\" data-ng-model=\"$root.form.event\" class=\"form-control\"></div><div class=\"input-row\"><input type=\"text\" required=\"\" placeholder=\"{{$root.switchText(\'Área de interes\',\'Area of interest\')}}\" data-ng-model=\"$root.form.date\" class=\"form-control\"></div><div class=\"input-row\"><button type=\"submit\" class=\"btn-theme {{$root.gustuTheme}}\">{{$root.switchText(\'Continuar\',\'Continue\')}}</button></div></form></div><div class=\"form-wrapper flex\" data-ng-if=\"$root.modalTab == 2\"><form action=\"\" data-ng-submit=\"$root.sendForm()\"><p class=\"form-help {{$root.gustuTheme}}\">{{$root.switchText(\'Gracias por escribirnos, nos pondremos en contacto lo antes posible.\', \'Thanks for writing, we will contact you as soon as possible.\')}}</p><a class=\"btn-theme {{$root.gustuTheme}}\" style=\"display: block; margin: auto; width: 100px; text-align: center;\" target=\"_blank\" href=\"{{$root.api+$root.pressKitSelected.file}}\">{{$root.switchText(\'Descargar\',\'Download\')}}</a></form></div></div></div>");
$templateCache.put("app/views/modals/modalrh.html","<div class=\"all-modal dark\"><div class=\"modal-center ta-center container-fluid modal-family\" customheight=\"\" autoscroll=\"true\"><div class=\"close-button\" data-ng-click=\"$root.closeModal()\"><i class=\"fas fa-times\"></i></div><div class=\"form-wrapper\" data-ng-if=\"$root.modalTab == 1\"><form action=\"\" data-ng-submit=\"$root.sendForm()\"><h3 class=\"form-title {{$root.gustuTheme}}\">{{$root.switchText(\'Recursos humanos\',\'Human Resources\')}}</h3><div class=\"input-row\"><input type=\"text\" required=\"\" placeholder=\"{{$root.switchText(\'Nombre\',\'Name\')}}\" data-ng-model=\"$root.form.name\" class=\"form-control\"></div><div class=\"input-row\"><input type=\"email\" required=\"\" placeholder=\"{{$root.switchText(\'Correo electrónico\',\'Email\')}}\" data-ng-model=\"$root.form.email\" class=\"form-control\"></div><div class=\"input-row\"><div data-ng-init=\"$root.pickArea($root.rharea[0])\" class=\"btn-group\" dropdown=\"\" is-open=\"$root.isopen\"><button id=\"single-button\" type=\"button\" class=\"btn btn-primary\" dropdown-toggle=\"\">{{ $root.translate($root.formData.area) }} <span class=\"caret\"></span></button><ul class=\"dropdown-menu {{$root.gustuTheme}}\" dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li role=\"menuitem\" data-ng-if=\"$index>0\" data-ng-repeat=\"a in $root.rharea\"><a href=\"#\" data-ng-click=\"$root.pickArea(a)\">{{ $root.translate(a) }}</a></li></ul></div></div><div class=\"input-row\"><input type=\"text\" required=\"\" placeholder=\"{{$root.switchText(\'Lugar de origen\',\'City\')}}\" data-ng-model=\"$root.form.city\" class=\"form-control\"></div><div class=\"input-row\"><textarea name=\"\" required=\"\" placeholder=\"{{$root.switchText(\'Mensaje\',\'Message\')}}\" data-ng-model=\"$root.form.message\" class=\"form-control\"></textarea></div><div class=\"input-row\"><button class=\"btn-theme {{$root.gustuTheme}}\">{{$root.switchText(\'Enviar\',\'Send\')}}</button></div></form></div><div class=\"form-wrapper flex\" data-ng-if=\"$root.modalTab == 2\"><form action=\"\" data-ng-submit=\"$root.sendForm()\"><p class=\"form-help {{$root.gustuTheme}}\">{{$root.switchText(\'Gracias por escribirnos, nos pondremos en contacto lo antes posible.\', \'Thanks for writing, we will contact you as soon as possible.\')}}</p></form></div></div></div>");
$templateCache.put("app/views/modals/modalservices.html","<div class=\"all-modal dark\"><div class=\"modal-center ta-center container-fluid modal-family\" customheight=\"\" autoscroll=\"true\"><div class=\"close-button\" data-ng-click=\"$root.closeModal()\"><i class=\"fas fa-times\"></i></div><div class=\"form-wrapper\" data-ng-if=\"$root.modalTab == 1\"><form action=\"\" data-ng-submit=\"$root.sendForm()\"><h3 class=\"form-title {{$root.gustuTheme}}\">{{$root.switchText(\'Servicios corporativos\',\'Corporate services\')}}</h3><div class=\"input-row\"><input type=\"text\" required=\"\" placeholder=\"{{$root.switchText(\'Nombre\',\'Name\')}}\" data-ng-model=\"$root.form.name\" class=\"form-control\"></div><div class=\"input-row\"><input type=\"email\" required=\"\" placeholder=\"{{$root.switchText(\'Correo electrónico\',\'Email\')}}\" data-ng-model=\"$root.form.email\" class=\"form-control\"></div><div class=\"input-row\"><input type=\"text\" required=\"\" placeholder=\"{{$root.switchText(\'Empresa\',\'Enterprise\')}}\" data-ng-model=\"$root.form.enterprise\" class=\"form-control\"></div><div class=\"input-row\"><input type=\"text\" required=\"\" placeholder=\"{{$root.switchText(\'Servicio de interes\',\'Service of interest\')}}\" data-ng-model=\"$root.form.service\" class=\"form-control\"></div><div class=\"input-row\"><button class=\"btn-theme {{$root.gustuTheme}}\">{{$root.switchText(\'Enviar\',\'Send\')}}</button></div></form></div><div class=\"form-wrapper flex\" data-ng-if=\"$root.modalTab == 2\"><form action=\"\" data-ng-submit=\"$root.sendForm()\"><p class=\"form-help {{$root.gustuTheme}}\">{{$root.switchText(\'Gracias por escribirnos, nos pondremos en contacto lo antes posible.\', \'Thanks for writing, we will contact you as soon as possible.\')}}</p></form></div></div></div>");
$templateCache.put("app/views/sections/blog.html","<div class=\"gustu-blog\"><div class=\"gustu-blog-row\"><div class=\"filters-box\" data-ng-class=\"{\'open\':$root.blogForm.isOpen}\"><a href=\"\" class=\"btn-theme\" data-ng-click=\"$root.openBlogForm()\">{{$root.switchText(\'Filtros\',\'Filters\')}}</a><div class=\"options\"><div class=\"opt left\"><p data-ng-click=\"$root.blogForm.filterBy=\'blogSources\'\" data-ng-class=\"{\'active\':$root.blogForm.filterBy==\'blogSources\'}\" class=\"opt-label\">{{$root.switchText(\'Fuente\',\'Source\')}}</p><p data-ng-click=\"$root.blogForm.filterBy=\'blogYears\'\" data-ng-class=\"{\'active\':$root.blogForm.filterBy==\'blogYears\'}\" class=\"opt-label\">{{$root.switchText(\'Año\',\'Year\')}}</p></div><div class=\"opt right\"><ul><li data-ng-repeat=\"opt in $root.wc[$root.blogForm.filterBy]\" data-ng-click=\"$root.pickFilter(opt)\"><i data-ng-show=\"!opt.selected\" class=\"far fa-square\"></i> <i data-ng-show=\"opt.selected\" class=\"far fa-check-square\"></i> {{opt.opt}}</li></ul></div><a href=\"\" class=\"btn-theme {{$root.gustuTheme}}\" data-ng-click=\"$root.loadBlog(true)\">{{$root.switchText(\'Aplicar\',\'Apply\')}}</a></div></div><form class=\"form-group input-group\" data-ng-submit=\"$root.loadBlog(true)\"><input type=\"text\" placeholder=\"{{$root.switchText(\'Buscar por título\',\'Search by title\')}}\" data-ng-model=\"$root.blogForm.params.filters.title.value\" class=\"form-control search\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"submit\"><i class=\"fas fa-search\"></i></button></span></form></div><div class=\"gustu-blog-row\"><div class=\"pagination-total\" data-ng-class=\"$root.currentModule\"><p class=\"result\">{{$root.switchText(\'Registros\', \'Records\')}}: {{$root.wc.Webblog.total}}</p></div><div class=\"pagination-nav-options\" data-ng-class=\"$root.currentModule\"><button data-ng-click=\"$root.changePage(1)\" data-ng-disabled=\"($root.blogForm.params.page)<=1\" type=\"button\" class=\"btn btn-theme {{$root.gustuTheme}}\">{{$root.switchText(\'Inicio\', \'First\')}}</button> <button data-ng-click=\"$root.changePage(\'decrease\')\" data-ng-disabled=\"($root.blogForm.params.page)<=1\" type=\"button\" class=\"btn btn-theme {{$root.gustuTheme}}\"><i class=\"fa fa-angle-left\" aria-hidden=\"true\"></i></button> <span>{{$root.wc.Webblog.current_page}} {{$root.switchText(\'de\', \'from\')}} {{$root.wc.Webblog.last_page}}</span> <button data-ng-click=\"$root.changePage(\'increase\')\" data-ng-disabled=\"($root.blogForm.params.page)>=$root.wc.Webblog.last_page\" type=\"button\" class=\"btn btn-theme {{$root.gustuTheme}}\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></button> <button data-ng-click=\"$root.changePage($root.wc.Webblog.last_page)\" data-ng-disabled=\"($root.blogForm.params.page)>=$root.wc.Webblog.last_page\" type=\"button\" class=\"btn btn-theme {{$root.gustuTheme}}\">{{$root.switchText(\'Último\', \'Last\')}}</button></div></div><div class=\"blog-box\" equalheight=\"\" targetclass=\"blog-box\" data-ng-repeat=\"b in $root.wc.Webblog.data\"><div class=\"blog-item\"><a class=\"blog-image\" target=\"_blank\" href=\"{{b.link}}\" data-ng-style=\"$root.imageBackground(b)\"><p data-ng-if=\"$root.translate(b.content)\" class=\"legend\">{{$root.translate(b.content)}}</p></a><p class=\"blog-title {{$root.gustuTheme}}\">{{b.title}}</p><p class=\"blog-desc\">{{b.source}}</p><p class=\"blog-desc\">{{b.date}}</p></div></div><div class=\"gustu-blog-row\"><div class=\"pagination-total\" data-ng-class=\"$root.currentModule\"><p class=\"result\">{{$root.switchText(\'Registros\', \'Records\')}}: {{$root.wc.Webblog.total}}</p></div><div class=\"pagination-nav-options\" data-ng-class=\"$root.currentModule\"><button data-ng-click=\"$root.changePage(1)\" data-ng-disabled=\"($root.blogForm.params.page)<=1\" type=\"button\" class=\"btn btn-theme {{$root.gustuTheme}}\">{{$root.switchText(\'Inicio\', \'First\')}}</button> <button data-ng-click=\"$root.changePage(\'decrease\')\" data-ng-disabled=\"($root.blogForm.params.page)<=1\" type=\"button\" class=\"btn btn-theme {{$root.gustuTheme}}\"><i class=\"fa fa-angle-left\" aria-hidden=\"true\"></i></button> <span>{{$root.wc.Webblog.current_page}} {{$root.switchText(\'de\', \'from\')}} {{$root.wc.Webblog.last_page}}</span> <button data-ng-click=\"$root.changePage(\'increase\')\" data-ng-disabled=\"($root.blogForm.params.page)>=$root.wc.Webblog.last_page\" type=\"button\" class=\"btn btn-theme {{$root.gustuTheme}}\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></button> <button data-ng-click=\"$root.changePage($root.wc.Webblog.last_page)\" data-ng-disabled=\"($root.blogForm.params.page)>=$root.wc.Webblog.last_page\" type=\"button\" class=\"btn btn-theme {{$root.gustuTheme}}\">{{$root.switchText(\'Último\', \'Last\')}}</button></div></div></div>");
$templateCache.put("app/views/sections/contact.html","<div class=\"gustu-blog\"><div class=\"contact-map\"><ng-map center=\"{{$root.agency.latitud}},{{$root.agency.longitud}}\" zoom=\"16\"><marker position=\"{{$root.agency.latitud}},{{$root.agency.longitud}}\"></marker></ng-map></div><div class=\"col-xs-12\"><div class=\"contact-text\" equalheight=\"\" targetclass=\"contact-text\"><p class=\"cont-title {{$root.gustuTheme}}\">{{$root.switchText(\'Reservas\',\'Reservations\')}}</p><p data-ng-bind-html=\"$root.translate($root.contactData[3].content)\"></p><a href=\"{{$root.reservationsLink}}\" target=\"_blank\" class=\"btn-theme {{$root.gustuTheme}}\">{{$root.switchText(\'Reservar\',\'Reserve\')}}</a></div><div class=\"contact-text\" equalheight=\"\" targetclass=\"contact-text\"><p class=\"cont-title {{$root.gustuTheme}}\">{{$root.switchText(\'Recursos humanos\',\'Human Resources\')}}</p><p data-ng-bind-html=\"$root.translate($root.contactData[4].content)\"></p><a href=\"\" class=\"btn-theme {{$root.gustuTheme}}\" data-ng-click=\"$root.showModal(\'modalrh\');\">{{$root.switchText(\'Contactar\',\'Contact\')}}</a></div></div><div class=\"col-xs-12\"><div class=\"contact-text\" equalheight=\"\" targetclass=\"contact-text\"><p class=\"cont-title {{$root.gustuTheme}}\">{{$root.switchText(\'Prensa y RRPP\',\'Press\')}}</p><p data-ng-bind-html=\"$root.translate($root.contactData[5].content)\"></p><a href=\"\" class=\"btn-theme {{$root.gustuTheme}}\" data-ng-click=\"$root.showModal(\'modalpress\');\">{{$root.switchText(\'Contactar\',\'Contact\')}}</a></div><div class=\"contact-text\" equalheight=\"\" targetclass=\"contact-text\"><p class=\"cont-title {{$root.gustuTheme}}\">{{$root.switchText(\'Servicios corporativos\',\'Corporate services\')}}</p><p data-ng-bind-html=\"$root.translate($root.contactData[6].content)\"></p><a href=\"\" class=\"btn-theme {{$root.gustuTheme}}\" data-ng-click=\"$root.showModal(\'modalservices\');\">{{$root.switchText(\'Contactar\',\'Contact\')}}</a></div></div><div class=\"col-xs-12\"><div class=\"contact-text\" equalheight=\"\" targetclass=\"contact-text\"><p class=\"cont-title {{$root.gustuTheme}}\">{{$root.switchText(\'Catering\',\'Catering\')}}</p><p data-ng-bind-html=\"$root.translate($root.contactData[7].content)\"></p><a href=\"\" class=\"btn-theme {{$root.gustuTheme}}\" data-ng-click=\"$root.showModal(\'modalcatering\');\">{{$root.switchText(\'Contactar\',\'Contact\')}}</a></div></div></div>");
$templateCache.put("app/views/sections/family.html","<div class=\"gustu-family\"><div class=\"member\" squareheight=\"\" targetclass=\"member\" data-ng-style=\"{\'background\': \'url(\' + $root.api+m.image + \')\'}\" data-ng-click=\"$root.showModal(\'modalfamily\');$root.pickMember(m)\" data-ng-repeat=\"m in $root.wc.Webgfamily\"><div class=\"mem-text\"><p>{{m.name}}</p></div></div></div>");
$templateCache.put("app/views/sections/presskit.html","<div class=\"gustu-blog\"><div class=\"blog-box\" data-ng-repeat=\"b in $root.wc.Webpresskit\"><div class=\"blog-item\"><a class=\"blog-image\" data-ng-click=\"$root.showModal(\'modalgallery\'); $root.pickGallery($root.wc.Webpresskit,$index)\" data-ng-style=\"$root.imageBackground(b)\"></a><p class=\"blog-desc\">{{b.title}}</p><a data-ng-click=\"$root.showModal(\'modalpresskit\');$root.pickPressItem(b)\" class=\"link-animated {{$root.gustuTheme}}\"><span class=\"line {{$root.gustuTheme}}\"></span> {{$root.switchText(\'Descargar\',\'Download\')}}</a></div></div></div>");}]);